import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId,
    search = '',
    filters = [],
    order = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.dep.getUserDepPage, {
        userId,
        search,
        filters,
        order,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || {};
};
